document.addEventListener('DOMContentLoaded', function () {
  function wrapTables() {
    const main = document.querySelector('main')
    if (!main) return

    const tables = main.querySelectorAll('table')

    tables.forEach((table) => {
      const parent = table.parentElement

      // skip if the table is already wrapped in .table-scroll
      if (parent && parent.classList.contains('table-scroll')) {
        return
      }

      // check if table overflows its container or has no offsetParent
      const tableOverflows = table.offsetWidth > table.parentElement.offsetWidth
      const isDetached = table.offsetParent === null

      if (tableOverflows || isDetached) {
        // create wrapper divs
        const tableContent = document.createElement('div')
        tableContent.classList.add('table-content')

        const tableScroll = document.createElement('div')
        tableScroll.classList.add('table-scroll')

        // add accessibility attributes
        tableScroll.setAttribute('tabindex', '0') // make the div focusable via keyboard
        tableScroll.setAttribute('role', 'region') // define as an ARIA landmark region for assistive tech
        tableScroll.setAttribute('aria-label', 'Scrollable table area') // give the region a label for context

        // wrap the table
        table.parentElement.insertBefore(tableContent, table)
        tableContent.appendChild(tableScroll)
        tableScroll.appendChild(table)
      }
    })
  }

  // run on load
  wrapTables()

  // run on resize
  window.addEventListener('resize', wrapTables)
})
